/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { LoadDataForm } from '../../modules/reports/state/dataForm.actions';
import { LoadDataFormPayload } from '../../modules/reports/state/dataForm.model';
import { map, mergeMap, switchMap, take } from 'rxjs/operators';
import { QueryService } from '../../modules/map/services/query.service';
import { LoggerService } from '../../modules/shared/services/logger.service';
import { DataFormDialogComponent } from '../../modules/reports/dataForm/data-form-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DataFormState } from '../../modules/reports/state/dataForm.state';

@Component({
    selector: 'dash-gis-report-edit-button',
    templateUrl: './report-edit-button.component.html',
})
export class ReportEditButtonComponent {
    @Output() public saved = new EventEmitter<void>();

    @Input() public label: string;
    @Input() public formName: string;
    @Input() public keys: any[];
    @Input() public selectionLayer: string;

    @Select(DataFormState.names) dataFormNames$: Observable<string[]>;

    constructor(
        private logger: LoggerService,
        private queryService: QueryService,
        private dialog: MatDialog,
        private store: Store,
    ) {}

    public edit() {
        this.queryService.getSingleSelection$(this.selectionLayer).pipe(
            take(1),
            map((selection) => {
                const payload: LoadDataFormPayload = {
                    name: this.formName,
                    initialSelection: selection,
                };
                if (this.keys) {
                    payload.keys = Array.isArray(this.keys) ? this.keys : [this.keys];

                }
                return payload;
            }),
            mergeMap(payload => this.store.dispatch(new LoadDataForm(payload))),
            switchMap(() => {
                return this.dialog.open(
                    DataFormDialogComponent,
                    { data: this.formName }
                ).afterClosed();
            }),
        ).subscribe(() => {
            this.saved.emit();
        });
    }

    get authorized$(): Observable<boolean> {
        return this.dataFormNames$.pipe(
            map(names => names.findIndex(name => this.formName === name) !== -1),
        );
    }
}
